import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Illustration from '../../Illustration';

import avatar from '@material-ui/core/colors/grey';

import {
  CardList,
  CardListItem,
  ColumnItem,
} from '../../core';

import {
  selectTaxCategoriesList,
} from '../../../store/selectors';

const styles = theme => ({
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
});

const TaxCategoryCards = ({ classes, taxCategories, handleSelect }) => {
  return (
    <CardList handleSelect={handleSelect}>
      {taxCategories.length > 0 &&
        taxCategories.map((taxCategory, i) => {
          return (
            <CardListItem key={i} item={taxCategory} handleSelect={handleSelect}>
              <ColumnItem>
                <Avatar className={classes.avatar}>
                  T
                </Avatar>
              </ColumnItem>
              <ColumnItem>
                <Typography noWrap variant="subheading">
                  {taxCategory.name}
                </Typography>
              </ColumnItem>
            </CardListItem>
          );
        })
      }
      {taxCategories.length === 0 &&
        <Illustration
          title="Tax Categories..."
          imgKey="passing_by_amber"
          explainerText="Do you like paying taxes… neither do we!! We provide a list of tax exemptions to get money back! Find them when entering receipts."
          addItemText="Click the Show button below to see the list and add or change as needed."
          />
      }
    </CardList>
  );
};

const mapStateToProps = (state) => ({
  taxCategories: selectTaxCategoriesList(state),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(TaxCategoryCards);



// WEBPACK FOOTER //
// ./src/components/admin/TaxCategories/TaxCategoryCards.jsx